(function(){
  var key='moaWishlistHandles';
  function get(){try{return JSON.parse(localStorage.getItem(key)||'[]')}catch(e){return []}}
  function refresh(){
    var list=get();
    document.querySelectorAll('[data-moa-wishlist]').forEach(function(btn){
      btn.style.pointerEvents='auto';
      btn.style.position='relative';
      btn.style.zIndex='30';
      var h=btn.getAttribute('data-handle');
      var on=list.indexOf(h)>-1;
      btn.classList.toggle('is-active',on);
      btn.innerHTML=on?'♥':'♡';
      btn.setAttribute('aria-label',on?'Remove from wishlist':'Add to wishlist');
    });
  }
  document.addEventListener('DOMContentLoaded',refresh);
  window.addEventListener('pageshow',refresh);
  setInterval(refresh,2000);
})();